import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { TABS } from "../../constants/MainTabs";
import DarkModeToggle from "../generic/DarkModeToggle";

interface MobileNavigationProps {
    isMenuOpen: boolean;
    setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleLogout: () => void;
    showLogin: () => void;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
                                                               isMenuOpen,
                                                               setIsMenuOpen,
                                                               handleLogout,
                                                               showLogin,
                                                           }) => {
    const { isLoggedIn } = useContext(UserContext);

    return (
        <div
            className={`
        fixed inset-0
        bg-gray-900 bg-opacity-95
        z-50
        transform transition-transform duration-300
        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}
      `}
        >
            {/* Container with full height to push footer items down */}
            <div className="flex flex-col h-full text-white">
                {/* Header / Close Button */}
                <div
                    className="text-4xl font-extrabold px-8 py-6 border-b border-gray-700 bg-gray-900 flex justify-between items-center">
                    <span>Menu</span>
                    <button
                        onClick={() => setIsMenuOpen(false)}
                        className="text-3xl font-bold hover:text-gray-500 transition duration-300 focus:outline-none"
                    >
                        &times;
                    </button>
                </div>

                {/* Main Menu Links (scrollable if needed) */}
                <ul className="flex flex-col px-8 py-6 space-y-6 text-2xl font-bold flex-grow overflow-y-auto mt-10">
                    {isLoggedIn ? (
                        TABS.map((tab) => (
                            <li key={tab.endpoint}>
                                <Link
                                    to={`/${tab.endpoint}`}
                                    className="mobile-nav-link"
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {tab.label}
                                </Link>
                            </li>
                        ))
                    ) : (
                        <li>
                            <button
                                onClick={() => {
                                    showLogin();
                                    setIsMenuOpen(false);
                                }}
                                className="mobile-nav-button-login focus:outline-none"
                            >
                                Login
                            </button>
                        </li>
                    )}
                </ul>

                {/* Footer: Logout or Login + Dark Mode at the bottom */}
                <div className="px-4 py-4 border-t border-gray-700 flex items-center justify-between">
                    {isLoggedIn && (
                        <button
                            onClick={() => {
                                handleLogout();
                                setIsMenuOpen(false);
                            }}
                            className="mobile-nav-button-logout focus:outline-none"
                        >
                            Logout
                        </button>
                    )}

                    {/* Dark Mode Toggle */}
                    <div className={"p-4"}>
                        <DarkModeToggle/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileNavigation;
